import React,{useState, useContext} from 'react'
import { GlobalContext } from '../../../../context/provider';
import moment from "moment/moment";
import numberbeautify from '../../../../utils/numberbeautify';
import money_rounding from '../../../../utils/money_rounding';

const Mizania_company_loan_out_table = ({loan_out}) => {
    return (
        <div>
            {/* Expense List Card */}
            <div className="bg-white border border-slate-100 rounded-xl shadow-sm overflow-x-auto"> 
            {/* Section Header */}
            <div className="flex items-center justify-between px-6 py-4 border-b border-slate-100">
                <h2 className="text-base font-semibold text-slate-800">لیستی قەرزی دراوەی کۆمپانیا</h2>
            </div>

            {/* Table */}
            <table className="w-full">
                <thead>
                    <tr className="bg-slate-50 border-b border-slate-100">
                        <th className="px-6 py-3 text-right text-xs font-semibold text-slate-500 uppercase tracking-wide">
                            ناوی کۆمپانیا
                        </th>
                        <th className="px-6 py-3 text-right text-xs font-semibold text-slate-500 uppercase tracking-wide">
                            بەرواری گەڕاندنەوە
                        </th>
                        <th className="px-6 py-3 text-right text-xs font-semibold text-slate-500 uppercase tracking-wide">
                            بڕی گەڕاوە
                        </th>
                        <th className="px-6 py-3 text-right text-xs font-semibold text-slate-500 uppercase tracking-wide">
                            تێبینی
                        </th>
                    </tr>
                </thead>
                <tbody className="divide-y divide-slate-50">
                    {loan_out?.map((lis)=>(
                    <tr key={lis.loan_out_id} className="hover:bg-slate-50 transition-colors duration-100">
                        <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                            {lis.company_name}
                        </td>
                        <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                            {moment(lis.loan_out_date).format("YYYY-MM-DD hh:mm a")}
                        </td>
                        <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                            {numberbeautify(money_rounding(lis.loan_out_amount))}
                        </td>
                        <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                            {lis?.loan_out_note}
                        </td>
                    </tr>
                    ))}
                </tbody>
            </table>
        </div>
    </div>
    )
}

export default Mizania_company_loan_out_table